import React, { useState } from "react";
// import Uvxcel_celebrations_images  from "../images/Uvxcel_celebrations_images";
import "./PhotoGallery.css";


// Dynamically import all images from a folder
function importAll(r) {
  return r.keys().map(r);
}

const images = importAll(require.context("../../images/Uvxcel_celebrations_images", false, /\.(png|jpe?g|svg)$/));

const UvxcelCelebrations = () => {
  const [showExtra, setShowExtra] = useState(false);
  const [selectedIndex, setSelectedIndex] = useState(null); // currently opened image index (or null)
  const visibleCount = 9;

  const visiblePhotos = images.slice(0, visibleCount);
  const remainingCount = images.length - visibleCount;
  const extraPhotos = images.slice(visibleCount + 1); // if you keep the 9th image as the overlay image

  const openAt = (index) => {
    setSelectedIndex(index);
  };

  const closeModal = () => {
    setSelectedIndex(null);
  };

  // Use functional updates and stop event bubbling
  const handleNext = (e) => {
    e.stopPropagation();
    setSelectedIndex((prev) => {
      const next = (prev + 1) % images.length;
      return next;
    });
  };

  const handlePrev = (e) => {
    e.stopPropagation();
    setSelectedIndex((prev) => {
      const prevIndex = prev === 0 ? images.length - 1 : prev - 1;
      return prevIndex;
    });
  };

  return (
    <section className="container our-team py-5">
      <h2 className="fw-bold primary-color-heading text-center-smallScreen reveal fade-up">
        Team Engagements
      </h2>

      <div className="photo-gallery">
        {visiblePhotos.map((photo, idx) => (
          <img
            key={idx}
            src={photo}
            alt={`Gallery ${idx + 1}`}
            // className="card"
            onClick={() => openAt(idx)}
          />
        ))}

        {/* +X overlay shown only when extras exist and not already expanded */}
        {!showExtra && remainingCount > 0 && (
          <div
            className="plus-overlay"
            data-plus={`+${remainingCount}`}
            onClick={() => setShowExtra(true)}
          >
            {/* clicking the image itself should open the lightbox on that image */}
            <img
              src={images[visibleCount]}
              alt="More photos"
              onClick={(e) => {
                e.stopPropagation(); // prevent overlay click from also toggling extra-photos
                openAt(visibleCount);
              }}
            />
          </div>
        )}
      </div>

      {showExtra && (
        <div className="extra-photos fade-in">
          {extraPhotos.map((photo, index) => (
            <img
              key={index + visibleCount + 1}
              src={photo}
              alt={`Extra ${index + 1}`}
              onClick={() => openAt(index + visibleCount + 1)}
            />
          ))}
        </div>
      )}

      {/* Lightbox */}
      {selectedIndex !== null && (
        <div className="lightbox-overlay" onClick={closeModal}>
          <span
            className="close-btn"
            onClick={(e) => {
              e.stopPropagation();
              closeModal();
            }}
          >
            &times;
          </span>

          {/* stopPropagation on the image so clicking does not close modal */}
          <img
            className="lightbox-image"
            src={images[selectedIndex]}
            alt="Selected"
            onClick={(e) => e.stopPropagation()}
          />

          {/* nav buttons — they stop propagation themselves */}
          <button className="nav-btn prev" 
          onClick={handlePrev}
           aria-label="Previous">
            &#10094;
          </button>
          <button className="nav-btn next" 
          onClick={handleNext} 
          aria-label="Next">
            &#10095;
          </button>

          <div className="lightbox-counter">
            {selectedIndex + 1} / {images.length}
          </div>
        </div>
      )}
    </section>
  );
};

export default UvxcelCelebrations;
